import React from 'react';
import PropTypes from 'prop-types';

function SimpleNoteWidget(props) {
    if (!props?.title && !props?.description) return null;

    return (
        <div data-test-id="simplenote-wr" className={"widget widget-simplenote" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto text-sm-center p-0">
                {props?.title ? <h3 data-test-id="simplenote-title" className={(props?.dark ? "text-white " : "") + "text-sm col-12"}>{props.title}</h3> : null}
                {props?.description ? <h2 data-test-id="simplenote-description" className={(props?.dark ? "text-white " : "") + "text-sm-big col-12"}>{props.description}</h2> : null}
            </div>
        </div>
    )
}

SimpleNoteWidget.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    widget: PropTypes.string
}

export default SimpleNoteWidget;
